enum LOCATION {
  MAP = 'map',
  LIST = 'list',
}

export const EModalSubTypes = {
  LOCATION,
};
